import React from 'react';
import { NotFoundView } from './NotFoundView';

export const NotFoundLogic = () => {
  return <NotFoundView />;
}; 